export default async function createSearchParamsString(searchParams: URLSearchParams) {
  let string = '?'
  searchParams.forEach((value, key) => {
    string += `${key}=${value}&`
  })
  return string.substring(0, string.length - 1)
}
